export default __webpack_public_path__ + "static/media/five_tou2.081ea7be.png";